export default function getHostUrl () {
  return window.location.protocol + '//' + window.location.host
}
